import { Injectable, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivate, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { UserStore } from '@signal-store';

@Injectable({
  providedIn: 'root',
})
export class SysAdminGuard implements CanActivate {
  private userStore = inject(UserStore);
  private userData$ = toObservable(this.userStore.userData);

  canActivate(): Observable<boolean | UrlTree> {
    return this.userData$.pipe(
      filter(userData => !!userData?.id),
      take(1),
      map(() => this.userStore.isSysAdmin()),
    );
  }
}
